import { styled } from '@mui/material/styles'
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

export const CardDrawer = styled(`div`)(({ theme }) => ({
    maxWidth: '300px',
    width: "100%",
    height: "100vh",
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px -1px rgba(16, 24, 40, 0.10)',
    transition: '.5s',
    overflow:'auto'
}))
export const HeadDrawer = styled(`div`)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px',
    borderBottom: '1px solid #026735',
}))
export const ListItemDrawer = styled(ListItem)(({ theme }) => ({
    display: 'block',
    // transition: ".5s",
    background: '#fff',
    '.active-toggle': {
        borderLeft: '4px solid #026735',
        paddingLeft: '16px',
        background: '#EFFFF7',
        width:'100%',
        '.MuiListItemIcon-root': {
            marginRight: "8px",
            transition: ".8s"
        },
    },
    '.active': {
        justifyContent: 'initial',
        padding: '12px !important',
        width:'100%',
        '.MuiListItemIcon-root': {
            marginRight: "8px",
            transition: ".5s"
        },
        '.MuiListItemText-root': {
            opacity: 0,
            width:'100%',
            transition: ".3s"
        },
    },

}))
export const ListItemButtonDrawer = styled(ListItemButton)(({ theme }) => ({
    minHeight: 48,
    justifyContent: 'center',
    padding: '12px 20px',
}))
export const ListItemIconDrawer = styled(ListItemIcon)(({ theme }) => ({
    width: "fit-content",
    marginRight: '8px',
    justifyContent: 'center',
    transition: ".5s"
}))
export const ListItemTextDrawer = styled(ListItemText)(({ theme }) => ({
    opacity: 1,
    whiteSpace: "nowrap",
    transition: '.5s',
    color: '#026735',
    width: '100%',
    '& .MuiTypography-root': {
        fontSize: '16px'
    }
}))

